import { render } from "./AfterReviewForm.vue?vue&type=template&id=539b7334"
import script from "./AfterReviewForm.vue?vue&type=script&lang=js"
export * from "./AfterReviewForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__